import Auth from '@aws-amplify/auth'
import fetch from 'node-fetch'

export async function isAuthenticated() {
  try {
    const session = await Auth.currentSession()
    const idToken = session.getIdToken().getJwtToken()
    return !!idToken
  } catch (err) {
    return false
  }
}

export function getItemsCountResponse(fullResponse: any) {
  return {
    items: fullResponse.data,
    totalCount: parseInt(fullResponse.headers.get('X-Total-Count')) || 0,
    pageCount: parseInt(fullResponse.headers.get('X-Page-Count')) || 0,
    lastKey: fullResponse.headers.get('X-Last-Key') || '',
  }
}

export async function apiFetchWithIdToken(method: string, url: string, body?: any, options?: any) {
  const session = await Auth.currentSession()
  const idToken = session.getIdToken().getJwtToken()
  return apiFetch(method, url, idToken, body, options)
}

export async function apiFetchWithAccessToken(method: string, url: string, body?: any, options?: any) {
  const session = await Auth.currentSession()
  const accessToken = session.getAccessToken().getJwtToken()
  return apiFetch(method, url, accessToken, body, options)
}

export async function apiFetchWithoutToken(method: string, url: string, body?: any, options?: any) {
  return apiFetch(method, url, undefined, body, options)
}

export async function apiFetch(method: string, url: string, authToken?: string, body?: any, options?: any) {
  if (!options) options = {}
  const fetchOptions: any = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
  }
  if (authToken) {
    fetchOptions.headers.Authorization = authToken
  }
  if (body !== undefined) {
    fetchOptions.body = JSON.stringify(body)
  }
  const response = await fetch(url, fetchOptions)
  if (!response.ok) {
    let errorText = await response.text()
    let errorMessage = 'HTTP ' + response.status + ': ' + errorText
    try {
      const errorObj = JSON.parse(errorText)
      if (errorObj.errorMessage) errorMessage = errorObj.errorMessage
    } catch (err) {
      // ignore invalid response
    }
    const err = new Error(errorMessage) as any
    err.httpStatus = '' + response.status
    throw err
  }
  const responseData = await response.json()
  if (options.fullResponse) {
    // Return status, headers and parsed JSON data
    return {
      status: response.status,
      headers: response.headers,
      data: responseData,
    }
  } else {
    // Just return parsed JSON data
    return responseData
  }
}
